import { render, staticRenderFns } from "./SalvageParts.vue?vue&type=template&id=9fd2861e&scoped=true"
import script from "./SalvageParts.vue?vue&type=script&lang=js"
export * from "./SalvageParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd2861e",
  null
  
)

export default component.exports